import { createSlice } from "@reduxjs/toolkit";

const metalRewardsSlice = createSlice({
  name: "metalRewards",
  initialState: {
    loading: false,
    list: [],
    total: 0,
    error: null,
    updating: false,
    page: 0,
    limit: 10,

    // For single reward details
    currentReward: null,
    rewardLoading: false,

    // For creating new reward
    creating: false,
    createdReward: null,
  },
  reducers: {
    // List fetch
    fetchMetalRewardsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchMetalRewardsSuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 0;
      state.limit = action.payload.limit || 10;
    },
    fetchMetalRewardsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update status
    updateStatusRequest: (state) => {
      state.updating = true;
    },
    updateStatusSuccess: (state, action) => {
      state.updating = false;
      state.list = state.list.map((item) =>
        item.id === action.payload.id
          ? { ...item, status: action.payload.status }
          : item
      );
    },
    updateStatusFailure: (state, action) => {
      state.updating = false;
      state.error = action.payload;
    },

    // Get single reward
    getMetalRewardRequest: (state) => {
      state.rewardLoading = true;
      state.error = null;
      state.currentReward = null;
    },
    getMetalRewardSuccess: (state, action) => {
      state.rewardLoading = false;
      state.currentReward = action.payload;
    },
    getMetalRewardFailure: (state, action) => {
      state.rewardLoading = false;
      state.error = action.payload;
    },

    // Create reward
    createMetalRewardRequest: (state) => {
      state.creating = true;
      state.error = null;
      state.createdReward = null;
    },
    createMetalRewardSuccess: (state, action) => {
      state.creating = false;
      state.createdReward = action.payload;
      state.list = [action.payload, ...state.list]; // add new to list
    },
    createMetalRewardFailure: (state, action) => {
      state.creating = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchMetalRewardsRequest,
  fetchMetalRewardsSuccess,
  fetchMetalRewardsFailure,
  updateStatusRequest,
  updateStatusSuccess,
  updateStatusFailure,
  getMetalRewardRequest,
  getMetalRewardSuccess,
  getMetalRewardFailure,
  createMetalRewardRequest,
  createMetalRewardSuccess,
  createMetalRewardFailure,
} = metalRewardsSlice.actions;

export default metalRewardsSlice.reducer;
